import { useEffect, useState } from 'react';
import type { StorefrontProduct } from '../../api/client';

// The option a product page is opened on lives in its address, as Sleek's does — /products/huile?variant=…
// — so a shared link or a reload lands on the same option, and picking another rewrites it in place. Only
// the product the address itself names follows it: a card or a bundle row elsewhere on the page keeps its
// own choice to itself.

// Says whether the address names this product: its own page, or a preview of it.
const namesProduct = (product: StorefrontProduct): boolean =>
  window.location.pathname.replace(/\/$/, '') === `/products/${encodeURIComponent(product.slug)}` || new URLSearchParams(window.location.search).get('product') === product.slug;

// Holds a product's chosen variant, read from and written to the address when the address names that product.
export function useAddressVariant(product: StorefrontProduct): [string, (variantId: string) => void] {
  const own = namesProduct(product);
  const [selected, select] = useState(() => (own ? new URLSearchParams(window.location.search).get('variant') ?? '' : ''));
  useEffect(() => {
    if (!own || selected === '' || !product.variants.some((row) => row.id === selected)) return;
    const params = new URLSearchParams(window.location.search);
    params.set('variant', selected);
    window.history.replaceState(window.history.state, '', `${window.location.pathname}?${params.toString()}`);
  }, [own, selected, product]);
  return [selected, select];
}
